

export const FAVORITE_SCRIPT = "FAVORITE_SCRIPT";
export const FAVORITED_SCRIPT = "FAVORITED_SCRIPT";
export const GET_SCRIPT = "GET_SCRIPT";

export const FAVORITED_SCRIPT_API_ERROR = "FAVORITED_SCRIPT_API_ERROR";
export const FAVORITED_SCRIPT_RESET_ERROR = "FAVORITED_SCRIPT_RESET_ERROR";
